import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';
import { isMultipleExceptions } from './utils';
export var ODTableExceptionBadge = function (_a) {
    var exceptions = _a.exceptions;
    var exceptionStatus = isMultipleExceptions(exceptions);
    if (exceptionStatus === undefined) {
        return null;
    }
    return (React.createElement(Badge, { variant: "subtle", color: "warning", size: "small" }, exceptionStatus));
};
